import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RequiredDocsUploadService {

  private uploadsPending = 0;
  public uploadPendingEmitter: EventEmitter<boolean> = new EventEmitter();

  constructor() { }

  trackNewPendingUpload() {
    this.uploadsPending++;
    this.uploadPendingEmitter.emit(true);
  }

  uploadAttemptComplete() {
    this.uploadsPending--;
    if (this.uploadsPending === 0) {
      this.uploadPendingEmitter.emit(false);
    }
  }
  

}
